<template>

  <Teleport to="body">
    <div class="in-dialog" v-if="watchingPost">
      <span class="cls" @click="boardViewOnOff(false)"></span>
      <div class="page">
        <dialog_boardView style="flex:1;" :thePost="watchingPost" :windowOnOff="boardViewOnOff" :reloadPost="fetchBoard" />
      </div>
    </div>
  </Teleport>

  <div class="my-buzz" v-if="content_all_loaded">

    <!-- 헤드 스택: 명예의 전당 + 시책 -->
    <div class="head-stack">
      <div class="banner" @click="openLeaderHall">
        <div class="banner-profile">
          <img :src="topRankers[0]?.image || '/imgs/unknow_user.png'" />
        </div>
        <div class="banner-content">
          <span class="banner-label">명예의 전당</span>
          <h1>🥇 {{ topRankers[0]?.mb_name || '-' }}</h1>
          <span class="banner-slogan">오늘의 1위도 어제의 도전에서 시작됐다.</span>
        </div>
        <button class="live-ranking-btn">
          <i class="ph-fill ph-video-camera"></i> LIVE 랭킹
        </button>
      </div>
      
      <div class="bounty-slot" @click="openPolicyList">
        <span class="slot-title"><i class="ph-fill ph-bell"></i> 이번 달 시책</span>
        
        <!-- 시책이 있을 때 -->
        <template v-if="activePolicies.length > 0">
          <div class="bounty-swiper">
            <div class="bounty-slides">
              <transition name="slide-fade" mode="out-in">
                <div 
                  class="bounty-slide" 
                  :key="currentPolicyIndex"
                >
                  <img class="bounty-company-img" :src="activePolicies[currentPolicyIndex]?.short_img || '/imgs/empty_image.png'" />
                  <div class="goldbar-wrapper">
                    <h2>최대 <b>{{ formatNumber(activePolicies[currentPolicyIndex]?.amount || 0) }}</b>%</h2>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          
          <!-- Indicator -->
          <div class="swiper-indicator">
            <span 
              v-for="(policy, index) in activePolicies" 
              :key="'ind-' + policy.idx"
              :class="['dot', { active: currentPolicyIndex === index }]"
              @click="goToPolicy(index)"
            ></span>
          </div>
        </template>
        
        <!-- 시책이 없을 때 -->
        <div class="bounty-empty" v-else>
          <i class="ph ph-calendar-x"></i>
          <p>진행 중인 시책이 없습니다</p>
        </div>
      </div>
    </div>

    <!-- 탭 섹션 -->
    <div class="tab-section">

      <!-- 탭 바 -->
      <div class="tab-bar">
        <div class="tab-list">
          <button 
            v-for="tab in tabs" 
            :key="tab.key"
            :class="['tab-item', { active: activeTab === tab.key }]"
            @click="activeTab = tab.key"
          >{{ tab.label }}</button>
        </div>
        <div class="tab-nav">
          <button class="tab-nav-btn" :disabled="!hasPrev" @click="prevPage"><i class="ph-bold ph-caret-left"></i></button>
          <button class="tab-nav-btn" :disabled="!hasNext" @click="nextPage"><i class="ph-bold ph-caret-right"></i></button>
        </div>
      </div>

      <!-- 탭 컨텐츠 -->
      <div class="tab-content">

        <!-- 지점 소식 -->
        <div class="stack" v-if="activeTab === 'sns'">
          <div class="header">
            <p>지점 소식</p>
            <button @click="openSnsList">더보기 <i class="ph-bold ph-caret-right"></i></button>
          </div>
          <ul class="blocks img-blocks" v-if="feedSnsPosts.length > 0">
            <li v-for="post in feedSnsPosts" :key="post.idx" @click="openSnsView(post.idx)">
              <img v-if="getPostImage(post.images)" :src="getPostImage(post.images)" />
              <div class="placeholder" v-else><i class="ph ph-article"></i></div>
              <h2>{{ post.title }}</h2>
              <small>{{ post.mb_id }}</small>
              <div class="status">
                <span><i class="ph ph-heart"></i> {{ post.like_count || 0 }}</span>
                <span><i class="ph ph-chat-circle"></i> {{ post.comment_count || 0 }}</span>
              </div>
            </li>
          </ul>
          <div class="empty-state" v-else>
            <i class="ph ph-article"></i>
            <p>아직 소식이 없습니다</p>
          </div>
        </div>

        <!-- 인기 Q&A -->
        <div class="stack" v-if="activeTab === 'qna'">
          <div class="header">
            <p> 인기 Q&A <span class="hot-badge">HOT</span></p>
            <button @click="openQnA">더보기 <i class="ph-bold ph-caret-right"></i></button>
          </div>
          <ul class="lines" v-if="hotQuestions.length > 0">
            <li v-for="(item, index) in hotQuestions" :key="item.idx" @click="openQnAView(item.idx)">
              <div class="line-left">
                <span class="rank" :class="{ top: index < 3 }">{{ index + 1 }}</span>
                <div class="line-info">
                  <p>{{ item.title }}</p>
                  <small v-if="item.category">#{{ item.category }}</small>
                </div>
              </div>
              <div class="line-stats">
                <span><i class="ph ph-eye"></i> {{ item.view_count || 0 }}</span>
                <span><i class="ph ph-chat-circle"></i> {{ item.answer_count || 0 }}</span>
              </div>
            </li>
          </ul>
          <div class="empty-state" v-else>
            <i class="ph ph-chat-circle"></i>
            <p>아직 Q&A가 없습니다</p>
          </div>
        </div>

        <!-- 청구사례 -->
        <div class="stack" v-if="activeTab === 'claim'">
          <div class="header">
            <p> 청구사례 공유</p>
            <button @click="openClaimExList">더보기 <i class="ph-bold ph-caret-right"></i></button>
          </div>
          <ul class="blocks img-blocks" v-if="hotClaimExPosts.length > 0">
            <li v-for="post in hotClaimExPosts" :key="post.idx" @click="openClaimExView(post.idx)">
              <img v-if="getPostImage(post.images)" :src="getPostImage(post.images)" />
              <div class="placeholder" v-else><i class="ph ph-clipboard-text"></i></div>
              <h2>{{ post.title }}</h2>
              <div class="status">
                <span><i class="ph ph-heart"></i> {{ post.like_count || 0 }}</span>
                <span><i class="ph ph-chat-circle"></i> {{ post.comment_count || 0 }}</span>
              </div>
            </li>
          </ul>
          <div class="empty-state" v-else>
            <i class="ph ph-clipboard-text"></i>
            <p>아직 청구사례가 없습니다</p>
          </div>
        </div>

        <!-- 공지사항 -->
        <div class="stack" v-if="activeTab === 'notice'">
          <div class="header">
            <p> 공지사항</p>
            <button @click="goToCategory(1)">더보기 <i class="ph-bold ph-caret-right"></i></button>
          </div>
          <ul class="blocks" v-if="a_board_list.length > 0">
            <li v-for="(item, index) in a_board_list" :key="index" @click="viewPost(item)">
              <img :src="item.thumb" />
              <h2>{{ item.title }}</h2>
              <small>{{ formatTime(item.created_at) }}</small>
              <div class="status">
                <span><i class="ph ph-heart"></i> {{ item.likes || 0 }}</span>
                <span><i class="ph ph-chat-circle"></i> {{ item.comments || 0 }}</span>
              </div>
            </li>
          </ul>
          <div class="empty-state" v-else>
            <i class="ph ph-megaphone"></i>
            <p>아직 공지사항이 없습니다</p>
          </div>
        </div>

        <!-- 아마 스토리 -->
        <div class="stack card-stack" v-if="activeTab === 'ama'">
          <ul class="card-stack-list">
            <li class="title-cover">
              <img src="https://amadiary.com/pub/acon/ama_logo_bg.png" class="brand-logo" />
              <h2>아마<br>스토리</h2>
            </li>
            <li class="card" v-for="(item, index) in paginatedSlice(ama_storys)" :key="index" @click="openView(item)">
              <img :src="item.thumb" class="card-bg" />
              <div class="card-overlay">
                <span class="category">{{ item.category || 'AMA' }}</span>
                <h2>{{ item.title }}</h2>
                <div class="status light">
                  <span><i class="ph ph-heart"></i> {{ item.likes }}</span>
                  <span><i class="ph ph-chat-circle"></i> {{ item.comments }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- 추천 자료 -->
        <div class="stack" v-if="activeTab === 'featured'">
          <div class="header">
            <p> {{ featured_category?.name || '추천 자료' }}</p>
            <button v-if="featured_category" @click="goToCategory(featured_category.idx)">더보기 <i class="ph-bold ph-caret-right"></i></button>
          </div>
          <ul class="blocks" v-if="featured_posts.length > 0">
            <li v-for="(item, index) in featured_posts" :key="index" @click="viewPost(item)">
              <img :src="item.thumb || '/imgs/empty_image.png'" />
              <h2>{{ item.title }}</h2>
              <small>{{ item.user_nick || '알 수 없음' }}</small>
              <div class="status">
                <span><i class="ph ph-heart"></i> {{ item.likes || 0 }}</span>
                <span><i class="ph ph-chat-circle"></i> {{ item.comments || 0 }}</span>
              </div>
            </li>
          </ul>
          <div class="empty-state" v-else>
            <i class="ph ph-star"></i>
            <p>아직 추천 자료가 없습니다</p>
          </div>
        </div>

      </div>

    </div>

  </div>

  <!-- 로더 -->
  <div class="loader" v-else>
    <div class="loader-content">
      <div class="spinner"></div>
      <p>콘텐츠를 불러오는 중...</p>
    </div>
  </div>

  <!-- SNS 리스트 다이얼로그 -->
  <SnsList 
    v-if="showSnsList" 
    :oth_showSnsList="toggleSnsList"
  />

  <!-- SNS 상세보기 다이얼로그 -->
  <SnsView 
    v-if="showSnsView" 
    :oth_showSnsView="toggleSnsView"
    :oth_showSnsEdit="toggleSnsEdit"
    :postIdx="snsViewIdx"
  />

  <!-- SNS 에디터 다이얼로그 -->
  <SnsEdit 
    v-if="showSnsEdit" 
    :oth_showSnsEdit="toggleSnsEdit"
    :editIdx="snsEditIdx"
  />

  <!-- Q&A 상세보기 다이얼로그 -->
  <QnAView 
    v-if="showQnAView" 
    :oth_showQnAView="toggleQnAView"
    :questionIdx="qnaViewIdx"
  />

  <!-- 청구사례 상세보기 다이얼로그 -->
  <ClaimExView 
    v-if="showClaimExView" 
    :oth_showClaimExView="toggleClaimExView"
    :postIdx="claimExViewIdx"
  />
</template>

<script>
import { inject, ref, computed, watch, onMounted, onUnmounted } from 'vue';
import dialog_boardView from '@/components/dialogs/boardView.vue';
import SnsList from '@/components/dialogs/snsList.vue';
import SnsView from '@/components/dialogs/snsView.vue';
import SnsEdit from '@/components/dialogs/snsEdit.vue';
import QnAView from '@/components/dialogs/QnAView.vue';
import ClaimExView from '@/components/dialogs/claimExView.vue';

export default {
  name: 'MySettings',
  components: {
    dialog_boardView,
    SnsList,
    SnsView,
    SnsEdit,
    QnAView,
    ClaimExView
  },
  props: {
    oth_showQnA: {
      type: Function,
      default: null
    },
    oth_showClaimExList: {
      type: Function,
      default: null
    },
    oth_showLeaderHall: {
      type: Function,
      default: null
    },
    oth_showPolicyList: {
      type: Function,
      default: null
    }
  },
  setup(props) {
    const getAmaStorys = inject('getAmaStorys');
    const sql_query = inject('sql_query');
    const getUserProfileInfo = inject('getUserProfileInfo');
    const ama_storys = ref([]);
    const main_item = ref({});
    const main_item_writer = ref({});
    const content_all_loaded = ref(false);
    const a_board_list = ref([]);

    const hotQuestions = ref([]);
    const hotClaimExPosts = ref([]);
    const hotSnsPosts = ref([]);
    const feedSnsPosts = ref([]);
    const topRankers = ref([]);
    const activePolicies = ref([]);

    // 탭 관련
    const activeTab = ref('sns');
    const tabs = [
      { key: 'sns', label: '지점 소식' },
      { key: 'qna', label: 'Q&A' },
      { key: 'claim', label: '청구사례' },
      { key: 'notice', label: '공지사항' },
      { key: 'ama', label: '아마 스토리' },
      { key: 'featured', label: '추천 자료' },
    ];

    // 페이지네이션 관련
    const currentPage = ref(0);
    const PAGE_SIZE = 5;
    const hasMoreItems = ref(false);

    const hasPrev = computed(() => currentPage.value > 0);
    const hasNext = computed(() => {
      if (activeTab.value === 'ama') {
        return (currentPage.value + 1) * PAGE_SIZE < ama_storys.value.length;
      }
      return hasMoreItems.value;
    });

    watch(activeTab, () => {
      currentPage.value = 0;
      fetchCurrentTab();
    });

    async function fetchCurrentTab() {
      const page = currentPage.value;
      switch (activeTab.value) {
        case 'sns': await fetchFeedSnsPosts(page); break;
        case 'qna': await fetchHotQuestions(page); break;
        case 'claim': await fetchHotClaimExPosts(page); break;
        case 'notice': await fetchBoard(page); break;
        case 'featured': await fetchFeaturedCategory(page); break;
        case 'ama': break;
      }
    }

    async function prevPage() {
      if (hasPrev.value) {
        currentPage.value--;
        await fetchCurrentTab();
      }
    }

    async function nextPage() {
      if (hasNext.value) {
        currentPage.value++;
        await fetchCurrentTab();
      }
    }

    function paginatedSlice(arr) {
      const start = currentPage.value * PAGE_SIZE;
      return arr.slice(start, start + PAGE_SIZE);
    }

    // 시책 슬라이더 관련
    const currentPolicyIndex = ref(0);
    let policySliderInterval = null;

    const FEATURED_CATEGORY_ID = 2;
    const featured_category = ref(null);
    const featured_posts = ref([]);

    // SNS 다이얼로그 상태
    const showSnsList = ref(false);
    const showSnsView = ref(false);
    const showSnsEdit = ref(false);
    const snsViewIdx = ref(null);
    const snsEditIdx = ref(null);

    // Q&A 다이얼로그 상태
    const showQnAView = ref(false);
    const qnaViewIdx = ref(null);

    // 청구사례 다이얼로그 상태
    const showClaimExView = ref(false);
    const claimExViewIdx = ref(null);

    function startPolicySlider() {
      if (policySliderInterval) clearInterval(policySliderInterval);
      
      policySliderInterval = setInterval(() => {
        if (activePolicies.value.length > 0) {
          currentPolicyIndex.value = (currentPolicyIndex.value + 1) % activePolicies.value.length;
        }
      }, 3000); // 3초마다 전환
    }

    function goToPolicy(index) {
      currentPolicyIndex.value = index;
      // 수동 클릭 시 타이머 리셋
      startPolicySlider();
    }

    async function fetchHotQuestions(page = 0) {
      try {
        const offset = page * PAGE_SIZE;
        const sql = `
          SELECT idx, title, category, view_count, answer_count
          FROM qna_question
          WHERE is_secret = 0
          ORDER BY (view_count + answer_count * 10) DESC
          LIMIT ${PAGE_SIZE + 1} OFFSET ${offset}
        `;
        const result = await sql_query(sql) || [];
        hasMoreItems.value = result.length > PAGE_SIZE;
        hotQuestions.value = result.slice(0, PAGE_SIZE);
      } catch (error) {
        console.error("인기 Q&A 불러오기 실패:", error);
      }
    }

    async function fetchHotClaimExPosts(page = 0) {
      try {
        const offset = page * PAGE_SIZE;
        const sql = `
          SELECT idx, title, content, images, like_count, comment_count, created_at
          FROM claim_ex_post
          ORDER BY (like_count * 5 + comment_count * 3) DESC
          LIMIT ${PAGE_SIZE + 1} OFFSET ${offset}
        `;
        const result = await sql_query(sql) || [];
        hasMoreItems.value = result.length > PAGE_SIZE;
        hotClaimExPosts.value = result.slice(0, PAGE_SIZE);
      } catch (error) {
        console.error("청구사례 불러오기 실패:", error);
      }
    }

    async function fetchHotSnsPosts(page = 0) {
      try {
        const offset = page * PAGE_SIZE;
        const sql = `
          SELECT idx, title, content, like_count, comment_count, created_at
          FROM sns_post
          ORDER BY (like_count * 5 + comment_count * 3) DESC
          LIMIT ${PAGE_SIZE + 1} OFFSET ${offset}
        `;
        const result = await sql_query(sql) || [];
        hasMoreItems.value = result.length > PAGE_SIZE;
        hotSnsPosts.value = result.slice(0, PAGE_SIZE);
      } catch (error) {
        console.error("커뮤니티 불러오기 실패:", error);
      }
    }

    async function fetchFeedSnsPosts(page = 0) {
      try {
        const offset = page * PAGE_SIZE;
        const sql = `
          SELECT 
            p.idx, 
            p.mb_id, 
            p.title, 
            p.content, 
            p.images, 
            p.created_at,
            (SELECT COUNT(*) FROM likes WHERE target_table = 'sns_post' AND target_idx = p.idx) AS like_count,
            (SELECT COUNT(*) FROM comment WHERE target_table = 'sns_post' AND target_idx = p.idx) AS comment_count
          FROM sns_post p
          ORDER BY p.created_at DESC
          LIMIT ${PAGE_SIZE + 1} OFFSET ${offset}
        `;
        const result = await sql_query(sql) || [];
        hasMoreItems.value = result.length > PAGE_SIZE;
        feedSnsPosts.value = result.slice(0, PAGE_SIZE);
      } catch (error) {
        console.error("커뮤니티 피드 불러오기 실패:", error);
      }
    }

    function getPostImage(images) {
      if (!images) return null;
      try {
        const arr = JSON.parse(images);
        return arr.length > 0 ? arr[0] : null;
      } catch {
        return null;
      }
    }

    function getPostImageCount(images) {
      if (!images) return 0;
      try {
        return JSON.parse(images).length;
      } catch {
        return 0;
      }
    }

    async function fetchTopRankers() {
      try {
        const now = new Date();
        const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
        
        const sql = `
          SELECT ms.mb_id, m.name as mb_name, m.image,
                 ms.sales_score, ms.activity_score, ms.eval_score
          FROM member_scores ms
          JOIN member m ON ms.mb_id = m.mb_id
          WHERE ms.score_date = '${currentMonth}'
          ORDER BY ms.sales_score DESC
          LIMIT 3
        `;
        const result = await sql_query(sql);
        topRankers.value = result || [];
      } catch (error) {
        console.error("랭킹 불러오기 실패:", error);
      }
    }

    async function fetchActivePolicies() {
      try {
        const now = new Date();
        const monthStart = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
        const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        const monthEndStr = `${monthEnd.getFullYear()}-${String(monthEnd.getMonth() + 1).padStart(2, '0')}-${String(monthEnd.getDate()).padStart(2, '0')}`;
        
        const sql = `
          SELECT 
            p.idx, p.company_idx, p.title, p.amount, p.start_date, p.expire_date,
            c.name as company_name, c.short_img
          FROM insu_policies p
          LEFT JOIN insu_company c ON p.company_idx = c.idx
          WHERE p.start_date <= '${monthEndStr}' AND p.expire_date >= '${monthStart}'
          ORDER BY p.amount DESC
          LIMIT 5
        `;
        const result = await sql_query(sql);
        activePolicies.value = result || [];
      } catch (error) {
        console.error("시책 불러오기 실패:", error);
      }
    }

    async function fetchFeaturedCategory(page = 0) {
      try {
        const categorySql = `SELECT * FROM board_category WHERE idx = ${FEATURED_CATEGORY_ID} AND status = '1'`;
        const categoryResult = await sql_query(categorySql);
        
        if (categoryResult.length > 0) {
          featured_category.value = categoryResult[0];
          
          const offset = page * PAGE_SIZE;
          const postsSql = `
            SELECT * FROM board_reference 
            WHERE category_id = ${FEATURED_CATEGORY_ID} 
            AND is_temp = '0' 
            ORDER BY created_at DESC 
            LIMIT ${PAGE_SIZE + 1} OFFSET ${offset}
          `;
          const postsResult = await sql_query(postsSql) || [];
          hasMoreItems.value = postsResult.length > PAGE_SIZE;
          const trimmed = postsResult.slice(0, PAGE_SIZE);
          
          const enrichedPosts = await Promise.all(trimmed.map(async (item) => {
            const userInfo = await getUserProfileInfo(item.mb_id);
            return {
              ...item,
              user_nick: userInfo?.nickname || '알 수 없음',
            };
          }));
          
          featured_posts.value = enrichedPosts;
        }
      } catch (error) {
        console.error("추천 카테고리 불러오기 실패:", error);
      }
    }

    function formatTime(dateString) {
      if (!dateString) return '';
      const now = new Date();
      const target = new Date(dateString);
      const diffMs = now - target;
      const diffDay = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      
      if (diffDay === 0) return '오늘';
      if (diffDay === 1) return '어제';
      if (diffDay < 7) return `${diffDay}일 전`;
      
      return `${target.getMonth() + 1}월 ${target.getDate()}일`;
    }

    function goToCategory(categoryId) {
      console.log('카테고리로 이동:', categoryId);
    }

    async function fetchBoard(page = 0) {
      try {
        const offset = page * PAGE_SIZE;
        const sql = `SELECT * FROM board_reference where category_id = '1' and is_temp = '0' ORDER BY created_at DESC LIMIT ${PAGE_SIZE + 1} OFFSET ${offset}`;
        const response = await sql_query(sql) || [];
        hasMoreItems.value = response.length > PAGE_SIZE;
        const trimmed = response.slice(0, PAGE_SIZE);
        main_item.value = trimmed[0] || {};
        if (main_item.value.mb_id) {
          const writer = await getUserProfileInfo(main_item.value.mb_id);
          main_item_writer.value = writer;
        }
        a_board_list.value = trimmed;
      } catch (error) {
        console.error("게시판 불러오기 실패:", error);
      }
    }

    onMounted(async () => {
      fetchBoard();
      fetchFeaturedCategory();
      fetchHotQuestions();
      fetchHotClaimExPosts();
      fetchHotSnsPosts();
      fetchFeedSnsPosts();
      fetchTopRankers();
      fetchActivePolicies();
      
      // 시책 슬라이더 시작
      startPolicySlider();
      
      try {
        const result = await getAmaStorys();
        ama_storys.value = result;
        content_all_loaded.value = true;
      } catch (error) {
        console.error('아마스토리 불러오기 실패:', error);
        content_all_loaded.value = true;
      }
    });

    onUnmounted(() => {
      if (policySliderInterval) {
        clearInterval(policySliderInterval);
      }
    });

    function openView(item) {
      window.open(item.link, '_blank');
    }

    function clicked() {
      alert('준비중');
    }

    function openQnA() {
      if (props.oth_showQnA) {
        props.oth_showQnA(true);
      } else {
        alert('Q&A 기능 준비중');
      }
    }

    function openQnAView(idx) {
      // 내부 다이얼로그로 직접 열기
      qnaViewIdx.value = idx;
      showQnAView.value = true;
    }

    // Q&A 다이얼로그 토글
    function toggleQnAView(show, options = {}) {
      if (show) {
        qnaViewIdx.value = options.questionIdx;
        showQnAView.value = true;
      } else {
        showQnAView.value = false;
        qnaViewIdx.value = null;
        if (options.refresh) {
          fetchHotQuestions();
        }
      }
    }

    // 청구사례 다이얼로그 토글
    function toggleClaimExView(show, options = {}) {
      if (show) {
        claimExViewIdx.value = options.postIdx;
        showClaimExView.value = true;
      } else {
        showClaimExView.value = false;
        claimExViewIdx.value = null;
        if (options.refresh) {
          fetchHotClaimExPosts();
        }
      }
    }

    function openClaimExView(idx) {
      // 내부 다이얼로그로 직접 열기
      claimExViewIdx.value = idx;
      showClaimExView.value = true;
    }

    // SNS 다이얼로그 토글 함수들
    function toggleSnsList(show, options = {}) {
      if (show) {
        showSnsList.value = true;
      } else {
        showSnsList.value = false;
        if (options.refresh) {
          fetchFeedSnsPosts();
          fetchHotSnsPosts();
        }
      }
    }

    function toggleSnsView(show, options = {}) {
      if (show) {
        snsViewIdx.value = options.postIdx;
        showSnsView.value = true;
      } else {
        showSnsView.value = false;
        snsViewIdx.value = null;
        if (options.refresh) {
          fetchFeedSnsPosts();
          fetchHotSnsPosts();
        }
      }
    }

    function toggleSnsEdit(show, options = {}) {
      if (show) {
        snsEditIdx.value = options.editIdx || null;
        showSnsEdit.value = true;
      } else {
        showSnsEdit.value = false;
        snsEditIdx.value = null;
        if (options.refresh) {
          fetchFeedSnsPosts();
          fetchHotSnsPosts();
        }
      }
    }

    function openSnsList() {
      toggleSnsList(true);
    }

    function openSnsView(idx) {
      toggleSnsView(true, { postIdx: idx });
    }

    function openClaimExList() {
      if (props.oth_showClaimExList) {
        props.oth_showClaimExList(true);
      } else {
        alert('청구사례 기능 준비중');
      }
    }

    function openLeaderHall() {
      if (props.oth_showLeaderHall) {
        props.oth_showLeaderHall(true);
      } else {
        alert('명예의 전당 기능 준비중');
      }
    }

    function openPolicyList() {
      if (props.oth_showPolicyList) {
        props.oth_showPolicyList(true);
      } else {
        alert('시책 기능 준비중');
      }
    }

    const watchingPost = ref(null);
    const boardViewShowing = ref(false);
    
    function viewPost(item) {
      watchingPost.value = item;
      boardViewOnOff(true);
    }

    function boardViewOnOff(b) {
      if (b) {
        boardViewShowing.value = true;
      } else {
        boardViewShowing.value = b;
        watchingPost.value = null;
      }
    }

    function formatNumber(num) {
      return num?.toLocaleString('ko-KR') || '0';
    }

    return {
      a_board_list,
      ama_storys,
      main_item,
      content_all_loaded,
      openView,
      viewPost,
      boardViewShowing,
      watchingPost,
      boardViewOnOff,
      fetchBoard,
      main_item_writer,
      featured_category,
      featured_posts,
      formatTime,
      formatNumber,
      goToCategory,
      clicked,
      hotQuestions,
      hotClaimExPosts,
      hotSnsPosts,
      feedSnsPosts,
      topRankers,
      activePolicies,
      currentPolicyIndex,
      goToPolicy,
      openQnA,
      openQnAView,
      openSnsList,
      openSnsView,
      openClaimExList,
      openClaimExView,
      openLeaderHall,
      openPolicyList,
      getPostImage,
      getPostImageCount,
      // SNS 다이얼로그 관련
      showSnsList,
      showSnsView,
      showSnsEdit,
      snsViewIdx,
      snsEditIdx,
      toggleSnsList,
      toggleSnsView,
      toggleSnsEdit,
      // Q&A 다이얼로그 관련
      showQnAView,
      qnaViewIdx,
      toggleQnAView,
      // 청구사례 다이얼로그 관련
      showClaimExView,
      claimExViewIdx,
      toggleClaimExView,
      // 탭 관련
      activeTab,
      tabs,
      // 페이지네이션
      currentPage,
      hasPrev,
      hasNext,
      prevPage,
      nextPage,
      paginatedSlice
    };
  },
};
</script>

<style scoped>
p, h1, h2 { margin: 0; padding: 0; }

/* 다이얼로그 */
.in-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(12px);
}

.in-dialog > .cls {
  position: absolute;
  inset: 0;
  z-index: -1;
}

.in-dialog > .page {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 80%;
  height: 90%;
  overflow: hidden;
}

/* 로더 */
.loader {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--color-surface-reverse);
  border-top-color: var(--color-brand);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loader-content p {
  color: var(--color-text-secondary);
  font-size: var(--font-size-base);
  margin: 0;
}

/* 메인 컨테이너 */
.my-buzz {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: hidden;
  box-sizing: border-box;
}

/* 탭 섹션 (탭바 + 컨텐츠 묶음) */
.tab-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 탭 바 */
.tab-bar {
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.tab-list {
  display: flex;
  gap: 8px;
  overflow-x: auto;
}

.tab-list::-webkit-scrollbar {
  height: 0px;
}

.tab-item {
  padding: 8px 20px;
  border-radius: 120px;
  border: 1.5px solid var(--color-surface-reverse);
  background: var(--color-surface-light);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-secondary);
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
}

.tab-item:hover {
  background: var(--color-surface-reverse);
}

.tab-item.active {
  background: var(--color-text-primary);
  color: var(--color-background);
  border-color: var(--color-text-primary);
}

/* 탭 네비게이션 (좌우 버튼) */
.tab-nav {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.tab-nav-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1.5px solid var(--color-surface-reverse);
  background: var(--color-surface-light);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  color: var(--color-text-secondary);
  transition: all 0.2s;
}

.tab-nav-btn:hover:not(:disabled) {
  background: var(--color-surface-reverse);
  color: var(--color-text-primary);
}

.tab-nav-btn:disabled {
  opacity: 0.3;
  cursor: default;
}

/* 탭 컨텐츠 */
.tab-content {
  flex: 1;
  min-height: 0;
}

/* 빈 상태 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  gap: 12px;
  color: var(--color-text-third);
}

.empty-state > i {
  font-size: 40px;
}

.empty-state > p {
  font-size: 14px;
  margin: 0;
}

/* 스택 (섹션 블록) */
.stack {
  border-radius: 12px;
  background: var(--color-background);
  padding: 24px;
  box-sizing: border-box;
  gap: 24px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-surface-reverse);
}

/* 헤더 */
.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 36px;
  align-items: center;
}

.header > p {
  font-size: 18px;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 8px;
}

.header .hot-badge {
  padding: 4px 8px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 4px;
}

.header > button {
  border: none;
  background: var(--color-surface-light);
  height: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  border-radius: 120px;
  font-weight: 600;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  color: var(--color-text-secondary);
  transition: all 0.2s;
}

.header > button:hover {
  background: var(--color-surface-reverse);
  color: var(--color-brand);
}

/* 헤드 스택 */
.head-stack {
  display: flex;
  gap: 24px;
}

.banner {
  background-image: url('~@/../public/imgs/common/golden_bg.png');
  background-position: center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  box-sizing: border-box;
  flex: 4;
  position: relative;
  overflow: hidden;
  padding: 24px 32px;
  cursor: pointer;
  transition: transform 0.3s;
  gap: 24px;
}

.banner:hover {
  transform: scale(1.01);
}

.banner-profile {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 4px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.banner-profile > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.banner-label {
  font-size: 16px;
  color: black;
  font-weight: 800;
}

.banner-content > h1 {
  font-size: 32px;
  font-weight: 800;
  color: black;
  margin: 0;
}

.banner-slogan {
  font-size: 16px;
  color: black;
  font-weight: 800;
}

.live-ranking-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 10px 20px;
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.live-ranking-btn:hover {
  background: #c62828;
}

/* 시책 슬롯 */
.bounty-slot {
  aspect-ratio: 30/35;
  background: linear-gradient(rgba(243,232,209,1), rgba(189,162,117,1));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 12px;
  padding: 12px;
  box-sizing: border-box;
  flex: 1;
  gap: 8px;
}

.bounty-slot .slot-title {
  font-size: 14px;
  font-weight: 700;
  color: #5d4e37;
  display: flex;
  align-items: center;
  gap: 6px;
}

.bounty-swiper {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.bounty-slides {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#000;
}

.bounty-slide {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
}

/* 슬라이드 트랜지션 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.4s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.bounty-company-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 12px;
  background: #fff;
}

.goldbar-wrapper {
  width: 90%;
  aspect-ratio: 45/16;
  background-image: url('~@/../public/imgs/common/goldbar.png');
  background-position: center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;
}

.goldbar-wrapper > h2 {
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 700;
}

.goldbar-wrapper > h2 > b {
  font-size: 30px;
  font-weight: 850;
}

/* Indicator */
.swiper-indicator {
  display: flex;
  gap: 6px;
  justify-content: center;
  padding-top: 4px;
}

.swiper-indicator .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(93, 78, 55, 0.3);
  cursor: pointer;
  transition: all 0.3s;
}

.swiper-indicator .dot:hover {
  background: rgba(93, 78, 55, 0.5);
}

.swiper-indicator .dot.active {
  width: 20px;
  border-radius: 4px;
  background: #5d4e37;
}

/* 시책 없음 */
.bounty-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #5d4e37;
  opacity: 0.6;
}

.bounty-empty > i {
  font-size: 32px;
}

.bounty-empty > p {
  font-size: 13px;
  margin: 0;
}

/* Lines (리스트형) */
ul.lines {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  padding: 0;
  margin: 0;
}

ul.lines > li {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  padding: 12px 16px;
  background: var(--color-surface-light);
  border-radius: 10px;
  transition: all 0.2s;
  box-sizing:border-box;
}

ul.lines > li:hover {
  background: var(--color-surface-reverse);
}

ul.lines .line-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

ul.lines .rank {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--color-surface-reverse);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text-secondary);
  flex-shrink: 0;
}

ul.lines .rank.top {
  background: linear-gradient(135deg, var(--color-brand), #ff8c00);
  color: #000;
}

ul.lines .line-info {
  flex: 1;
  min-width: 0;
}

ul.lines .line-info > p {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

ul.lines .line-info > small {
  font-size: 12px;
  color: var(--color-special-point);
}

ul.lines .line-stats {
  display: flex;
  gap: 12px;
}

ul.lines .line-stats > span {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: var(--color-text-secondary);
}

/* 카드 스택 */
.stack.card-stack {
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(8px);
  border: none;
}

ul.card-stack-list {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  gap: 16px;
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-x: auto;
}

ul.card-stack-list::-webkit-scrollbar {
  height: 0px;
}

ul.card-stack-list::-webkit-scrollbar-thumb {
  display:none;
}

ul.card-stack-list > li {
  aspect-ratio: 30/35;
  cursor: pointer;
  min-width: 160px;
  max-width: 180px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  transition: transform 0.3s;
}

ul.card-stack-list > li:hover {
  transform: translateY(-6px);
}

ul.card-stack-list > li.title-cover {
  align-items: center;
  justify-content: center;
  background: none;
  min-width: 120px;
}

ul.card-stack-list > li.title-cover h2 {
  font-size: 32px;
  color: #fff;
  background: none;
  text-align: center;
  font-weight: 800;
  line-height: 1.2;
}

ul.card-stack-list > li.title-cover .brand-logo {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  margin-bottom: 12px;
}

/* 아마스토리 카드 */
ul.card-stack-list > li.card {
  position: relative;
  overflow: hidden;
  padding: 0;
}

ul.card-stack-list > li.card .card-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}

ul.card-stack-list > li.card:hover .card-bg {
  transform: scale(1.05);
}

ul.card-stack-list > li.card .card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(to top, rgba(0,0,0,0.9), transparent);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

ul.card-stack-list > li.card .category {
  font-size: 11px;
  color: rgba(255,255,255,0.8);
  padding: 4px 8px;
  background: rgba(255,255,255,0.2);
  border-radius: 20px;
  width: fit-content;
}

ul.card-stack-list > li.card h2 {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Blocks (그리드형) */
ul.blocks {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  gap: 16px;
  list-style: none;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
}

ul.blocks > li {
  cursor: pointer;
  width: calc(20% - 13px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: transform 0.2s;
}

ul.blocks > li:hover {
  transform: translateY(-4px);
}

ul.blocks > li > img {
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 12px;
  background: var(--color-surface-light);
  object-fit: cover;
}

ul.blocks > li > .placeholder {
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 12px;
  background: var(--color-surface-light);
  display: flex;
  align-items: center;
  justify-content: center;
}

ul.blocks > li > .placeholder > i {
  font-size: 32px;
  color: var(--color-text-third);
}

ul.blocks > li > h2 {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

ul.blocks > li > p {
  font-size: 13px;
  color: var(--color-text-secondary);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}

ul.blocks > li > small {
  font-size: 12px;
  color: var(--color-text-secondary);
}

ul.blocks > li > .block-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

ul.blocks > li > .block-content > h2 {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

ul.blocks > li > .block-content > p {
  font-size: 13px;
  color: var(--color-text-secondary);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}

/* Status */
.status {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  font-size: 13px;
}

.status > span {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--color-text-secondary);
}

.status.light > span {
  color: rgba(255,255,255,0.8);
}

/* 반응형 */
@media (max-width: 1280px) {
  ul.blocks > li {
    width: calc(25% - 12px);
  }
}

@media (max-width: 1024px) {
  .head-stack {
    flex-direction: column;
  }
  
  .banner {
    padding: 20px 24px;
  }
  
  .bounty-slot {
    aspect-ratio: auto;
    flex-direction: column;
    padding: 16px 24px;
    gap: 12px;
  }
  
  .bounty-swiper {
    flex: unset;
    width: 100%;
    min-height: 100px;
  }
  
  .bounty-slide {
    flex-direction: row;
    gap: 16px;
  }
  
  .bounty-company-img {
    width: 48px;
    height: 48px;
  }
  
  .goldbar-wrapper {
    width: auto;
    padding: 8px 24px;
    aspect-ratio: auto;
    flex: 1;
    max-width: 200px;
    color:#000;
  }
  
  .goldbar-wrapper > h2 {
    margin-bottom: 0;
    font-size: 16px;
  }
  
  .goldbar-wrapper > h2 > b {
    font-size: 24px;
  }
  
  .swiper-indicator {
    padding-top: 0;
  }
  
  ul.blocks > li {
    width: calc(33.33% - 11px);
  }
  
  ul.card-stack-list > li {
    min-width: 140px;
    max-width: 160px;
  }
}

@media (max-width: 768px) {
  .my-buzz {
    gap: 16px;
  }
  
  .stack {
    padding: 16px;
    gap: 16px;
  }
  
  .banner {
    padding: 16px 20px;
    gap: 16px;
  }
  
  .banner-profile {
    width: 70px;
    height: 70px;
  }
  
  .banner-content > h1 {
    font-size: 24px;
  }
  
  .banner-label,
  .banner-slogan {
    font-size: 12px;
  }
  
  .live-ranking-btn {
    padding: 8px 14px;
    font-size: 12px;
  }
  
  ul.blocks > li {
    width: calc(50% - 8px);
  }
  
  ul.card-stack-list > li {
    min-width: 120px;
    max-width: 140px;
  }
  
  ul.card-stack-list > li.title-cover h2 {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .in-dialog > .page {
    width: 100%;
    height: 100%;
  }
  
  .header > p {
    font-size: 16px;
  }
  
  .banner {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }
  
  .banner-profile {
    width: 60px;
    height: 60px;
  }
  
  .banner-content {
    align-items: center;
  }
  
  .banner-content > h1 {
    font-size: 20px;
  }
  
  .live-ranking-btn {
    position: relative;
    top: auto;
    right: auto;
    margin-top: 12px;
  }
  
  ul.blocks > li {
    width: 100%;
  }
  
  ul.lines > li {
    padding: 10px 12px;
  }
  
  ul.lines .rank {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
}
</style>